(function() {
  'use strict';

  angular.module("app")
    .constant("version", "0.9.0");

})();